import React, { useState } from "react";
import Sidebar, { SidebarContent } from "./Sidebar";
import { Outlet, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetTrigger,
} from "@/components/ui/sheet";
import Logo from "./Logo";

const Layout: React.FC = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col md:flex-row h-screen overflow-hidden">
      {/* Desktop Sidebar */}
      <Sidebar />

      {/* Mobile Header */}
      <div className="md:hidden flex items-center justify-between p-4 border-b bg-white dark:bg-gray-800 shrink-0">
        <div className="flex items-center gap-3">
          <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" className="-ml-2">
                <Menu className="h-6 w-6" />
                <span className="sr-only">Open menu</span>
              </Button>
            </SheetTrigger>
            <SheetContent side="left" className="p-0 w-72">
              <SidebarContent
                collapsed={false}
                isMobile
                onNavigate={() => setMobileOpen(false)}
              />
            </SheetContent>
          </Sheet>
          
          <Link to="/" className="flex items-center gap-2">
            <Logo size={24} className="h-6 w-6" />
            <span className="font-bold text-lg dark:text-white truncate">
              {t("app.title")}
            </span>
          </Link>
        </div>
      </div>

      {/* Main Content */}
      <main className="flex-grow overflow-y-auto">
        <div className="container mx-auto p-4 md:p-8 pb-20 md:pb-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout;
